import { Download, ExternalLink } from "lucide-react";
import { mediaUrl } from "@/lib/api";

function embedUrl(u) {
  const yt = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = u.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
}

export function VideoBlock({ url }) {
  if (!url) return null;
  const e = embedUrl(url);
  return (
    <div className="overflow-hidden rounded-[28px] bg-bt-primary" data-testid="resource-video">
      {e ? (
        <iframe src={e} title="Video" className="aspect-video w-full" allow="accelerometer; autoplay; encrypted-media; picture-in-picture" allowFullScreen />
      ) : (
        <video src={mediaUrl(url)} controls className="aspect-video w-full" />
      )}
    </div>
  );
}

export function AudioBlock({ url, label = "Listen" }) {
  if (!url) return null;
  return (
    <div className="rounded-[24px] bg-bt-sage p-5" data-testid="resource-audio">
      <p className="eyebrow mb-3">{label}</p>
      <audio src={mediaUrl(url)} controls className="w-full" />
    </div>
  );
}

export function LinksBlock({ downloads = [], links = [] }) {
  const all = [...downloads.map((d) => ({ ...d, dl: true })), ...links].filter((x) => x.url);
  if (!all.length) return null;
  return (
    <div className="space-y-3" data-testid="resource-downloads">
      <p className="eyebrow">Downloads & links</p>
      {all.map((d, i) => (
        <a key={i} href={mediaUrl(d.url)} target="_blank" rel="noopener noreferrer" data-testid={`resource-link-${i}`}
          className="flex min-h-[56px] items-center justify-between rounded-2xl border border-bt-border bg-bt-surface px-5 py-3 font-medium text-bt-heading transition-colors hover:border-bt-primary">
          {d.label || "Open"} {d.dl ? <Download size={18} /> : <ExternalLink size={18} />}
        </a>
      ))}
    </div>
  );
}
